import {combineReducers} from 'redux';
import {createReducer} from 'typesafe-actions';
import {
  clearData,
  clearModel,
  loadModelAsync,
  loadPlateDetailAsync,
  loadPlatesAsync,
  requestVotingAsync,
  requestVotingClear,
  setVotedPlate,
} from './actions';
import {
  IElection,
  IPlate,
  IPlateDetail,
  IVoting,
  PlateVoteStatusEnum,
} from './types';
import IInfo = MyTypes.IInfo;

const info = createReducer<IInfo>({loading: false, message: ''}) //
  .handleAction(
    [
      loadModelAsync.request,
      loadPlatesAsync.request,
      loadPlateDetailAsync.request,
      requestVotingAsync.request,
    ],
    () => ({
      loading: true,
      message: '',
    })
  )
  .handleAction(
    [
      clearData,
      loadModelAsync.success,
      loadPlatesAsync.success,
      loadPlateDetailAsync.success,
      requestVotingAsync.success,
    ],
    () => ({
      loading: false,
      message: '',
    })
  )
  .handleAction(
    [
      loadModelAsync.failure,
      loadPlatesAsync.failure,
      loadPlateDetailAsync.failure,
      requestVotingAsync.failure,
    ],
    (state, action) => ({
      loading: false,
      message: action.payload,
    })
  );

const model = createReducer<IElection | null>(null) //
  .handleAction(loadModelAsync.success, (state, action) => ({
    ...action.payload,
  }))
  .handleAction([clearModel], () => null);

const plates = createReducer<IPlate[]>([]) //
  .handleAction(loadPlatesAsync.success, (state, action) => [...action.payload])
  .handleAction(setVotedPlate, (state, action) =>
    state.map(plate => {
      if (plate.uuid === action.payload) {
        plate.status = PlateVoteStatusEnum.VOTED;
      }
      return {...plate};
    })
  )
  .handleAction(clearData, (state, action) => []);

const currentPlate = createReducer<IPlateDetail | null>(null) //
  .handleAction(loadPlateDetailAsync.success, (state, action) => ({
    ...action.payload,
  }))
  .handleAction(clearData, (state, action) => null);

const vote = createReducer<IVoting | null>(null) //
  .handleAction(requestVotingAsync.success, (state, action) => ({
    ...action.payload,
  }))
  .handleAction([clearData, requestVotingClear], (state, action) => null);

const electionReducer = combineReducers({
  info,
  model,
  plates,
  currentPlate,
  vote,
});

export default electionReducer;
export type ElectionState = ReturnType<typeof electionReducer>;



// WEBPACK FOOTER //
// ./src/features/election/store/reducer.ts